<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2>{{ $t('_bqyy._bqyy') }}</h2>
        <button class="close-btn" @click="$emit('close')">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="confirm-text">{{ $t('_bqyy._qrbq') }}</div>

        <div class="reservation-form">
          <div class="form-actions">
            <button type="button" class="cancel-btn" @click="$emit('close')">
              {{ $t('_bqyy._qx') }}
            </button>
            <button type="submit" class="submit-btn" @click="handleSubmit">
              <i class="fas fa-paper-plane"></i>
              {{ $t('_bqyy._tjyy') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReservationForm',
  data() {
    return {
      formData: {
        name: '',
        phone: ''
      }
    }
  },
  methods: {
    closeModal(e) {
      if (e.target.classList.contains('modal-overlay')) {
        this.$emit('close')
      }
    },
    handleSubmit() {
      this.$emit('submit', this.formData)
    }
  }
}
</script>

<style scoped>
/* ============================================================
   预约表单弹窗 - 深灰主题
   ============================================================ */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10003;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: #1a1f26;
  border-radius: 16px;
  max-width: 480px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid #2a3038;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 滚动条美化 */
.modal-content::-webkit-scrollbar {
  width: 4px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #2a3038;
  border-radius: 4px;
}

/* ============================================================
   头部
   ============================================================ */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #2a3038;
}

.modal-header h2 {
  color: #e8edf2;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.close-btn {
  background: transparent;
  border: none;
  color: #5a6672;
  cursor: pointer;
  padding: 4px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.04);
  color: #e8edf2;
  transform: rotate(90deg);
}

.close-btn svg {
  width: 20px;
  height: 20px;
}

/* ============================================================
   主体
   ============================================================ */
.modal-body {
  padding: 24px 28px 28px;
}

.confirm-text {
  color: #b0bcc8;
  font-size: 15px;
  line-height: 1.7;
  padding: 16px 20px;
  background: #0f1419;
  border-radius: 10px;
  border: 1px solid #2a3038;
  margin-bottom: 24px;
  text-align: center;
}

/* ============================================================
   表单
   ============================================================ */
.reservation-form {
  display: flex;
  flex-direction: column;
}

/* ============================================================
   操作按钮
   ============================================================ */
.form-actions {
  display: flex;
  gap: 12px;
}

.cancel-btn {
  flex: 1;
  padding: 12px 20px;
  border: 1px solid #2a3038;
  border-radius: 10px;
  background: transparent;
  color: #8a949f;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: #3a4652;
  color: #e8edf2;
}

.submit-btn {
  flex: 2;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

.submit-btn:active {
  transform: scale(0.97);
}

.submit-btn i {
  font-size: 14px;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 480px) {
  .modal-overlay {
    padding: 12px;
  }

  .modal-content {
    border-radius: 12px;
    max-height: 95vh;
  }

  .modal-header {
    padding: 14px 18px;
  }

  .modal-header h2 {
    font-size: 17px;
  }

  .modal-body {
    padding: 18px 18px 20px;
  }

  .confirm-text {
    font-size: 14px;
    padding: 12px 16px;
  }

  .form-actions {
    flex-direction: column;
    gap: 10px;
  }

  .cancel-btn,
  .submit-btn {
    padding: 11px 16px;
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  .modal-header h2 {
    font-size: 15px;
  }

  .confirm-text {
    font-size: 13px;
    padding: 10px 12px;
  }

  .cancel-btn,
  .submit-btn {
    font-size: 13px;
    padding: 10px 14px;
  }
}
</style>